import { CATEGORIES, type Category } from "../data/categories";
import { EmptyOptionsError, pickExcluding, sampleN, shuffle, unique, weightedPick } from "./random";

export interface SuggestOptions {
  filters?: string[];
  custom?: string[];
  customOnly?: boolean;
  dislikes?: string[];
  exclude?: string;
}

export interface Suggestion {
  result: string;
  more: string[];
  reel: string[];
  wheel: string[];
  category: Category;
}

export const dislikeWeight = (dislikes: string[] = []) => (label: string) => (dislikes.includes(label) ? 0.35 : 1);

export function buildPool(cat: Category, opts: SuggestOptions = {}): string[] {
  const filters = opts.filters || [];
  const curated = cat.items.filter((i) => !filters.length || i.tags.some((t) => filters.includes(t))).map((i) => i.label);
  const custom = opts.custom || [];
  return unique(opts.customOnly ? custom : [...curated, ...custom]);
}

export function suggest(cat: Category, opts: SuggestOptions = {}): Suggestion {
  const pool = buildPool(cat, opts);
  if (!pool.length) throw new EmptyOptionsError("No options match — loosen the filters or add your own.");
  const result = pickExcluding(pool, opts.exclude, dislikeWeight(opts.dislikes));
  const others = pool.filter((p) => p !== result);
  const wheel = shuffle([result, ...sampleN(others, 7)]);
  while (wheel.length < 4) wheel.push(...wheel.slice(0, 4 - wheel.length));
  return { result, more: sampleN(others, 3), reel: shuffle(pool).slice(0, 12), wheel, category: cat };
}

export function stuckPick(dislikes: string[] = [], exclude?: string, favouriteCategories: string[] = []): Suggestion {
  const cat = weightedPick(CATEGORIES, (c) => (favouriteCategories.includes(c.id) ? 3 : 1));
  const s = suggest(cat, { dislikes, exclude });
  const mixed = shuffle(CATEGORIES.flatMap((c) => c.items.map((i) => i.label))).slice(0, 14);
  return { ...s, reel: mixed };
}
